module.exports = __webpack_public_path__ + "mainassets/img/arrow-down.56498ec3.svg";